import {useState, useEffect} from 'react';

interface UseResponsiveVideoParams {
    portraitSource: string;
    landscapeSource: string;
    portraitImgSource: string;
    landscapeImgSource: string;
}

interface UseResponsiveVideoReturn {
    source: string;
    imgSource: string;
}

export const useResponsiveVideo = ({
    portraitSource,
    landscapeSource,
    portraitImgSource,
    landscapeImgSource
}: UseResponsiveVideoParams): UseResponsiveVideoReturn => {
    const [source, setSource] = useState(
        window.matchMedia('(orientation: portrait)').matches
            ? portraitSource
            : landscapeSource
    );
    const [imgSource, setImgSource] = useState(
        window.matchMedia('(orientation: portrait)').matches
            ? portraitImgSource
            : landscapeImgSource
    );

    useEffect(() => {
        const handleOrientationChange = (event: MediaQueryListEvent) => {
            const isPortrait = event.matches;
            setSource(isPortrait ? portraitSource : landscapeSource);
            setImgSource(isPortrait ? portraitImgSource : landscapeImgSource);
        };

        const mediaQuery = window.matchMedia('(orientation: portrait)');
        // Initial check to set the correct source
        handleOrientationChange({
            matches: mediaQuery.matches
        } as MediaQueryListEvent);

        // Add listener for orientation changes
        mediaQuery.addEventListener('change', handleOrientationChange);

        return () => {
            mediaQuery.removeEventListener('change', handleOrientationChange);
        };
    }, [
        portraitSource,
        landscapeSource,
        portraitImgSource,
        landscapeImgSource
    ]);

    return {
        source,
        imgSource
    };
};
